import { translateDay, getLessonBellTime } from 'features/schedule/utils';
import { educationParallelTextRepresentation } from 'entities/education-class';
import type {
  EducationClass,
  ScheduleConfigurationPrePublishCheckDto,
  DayOfWeek,
  Lesson,
  BellSchedule,
} from 'services/api';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';

export const prePublishErrorsColumns = (
  code: string,
  currentBellSchedule: BellSchedule | null,
): AppTableColumn<Omit<ScheduleConfigurationPrePublishCheckDto, 'code'>>[] => {
  switch (code) {
    case 'NO_ROOM_FOR_SUBJECT':
      return [
        {
          key: 'subjectName',
          title: 'Предмет',
          dataIndex: ['subjectName'],
        },
      ];
    case 'NO_TEACHER_FOR_CLASS_SUBJECT':
      return [
        {
          key: 'educationalClass',
          title: 'Класс',
          dataIndex: ['educationalClass'],
          maxWidth: '100px',
          render: (value: EducationClass) =>
            `${educationParallelTextRepresentation[value.parallel]}${value.litera}`,
        },
        {
          key: 'subjectName',
          title: 'Предмет',
          dataIndex: ['subjectName'],
        },
      ];
    case 'NO_TEACHER_FOR_GROUP_CLASS':
      return [
        {
          key: 'educationalClass',
          title: 'Класс',
          dataIndex: ['educationalClass'],
          maxWidth: '100px',
          render: (value: EducationClass) =>
            `${educationParallelTextRepresentation[value.parallel]}${value.litera}`,
        },
        {
          key: 'subjectName',
          title: 'Предмет',
          dataIndex: ['subjectName'],
        },
        {
          key: 'groupName',
          title: 'Группа',
          dataIndex: ['groupName'],
        },
      ];
    case 'CLASS_CAPACITY_EXCEEDED':
      return [
        {
          key: 'educationalClass',
          title: 'Класс',
          dataIndex: ['educationalClass'],
          maxWidth: '100px',
          render: (value: EducationClass) =>
            `${educationParallelTextRepresentation[value.parallel]}${value.litera}`,
        },
        {
          key: 'totalClassHours',
          title: 'Общее количество учебных часов',
          dataIndex: ['totalClassHours'],
        },
        {
          key: 'maxAvailableSlots',
          title: 'Доступное количество слотов',
          dataIndex: ['maxAvailableSlots'],
        },
      ];
    case 'ROOM_CAPACITY_EXCEEDED':
      return [
        {
          key: 'subjectName',
          title: 'Предмет',
          dataIndex: ['subjectName'],
        },
        {
          key: 'totalSubjectHours',
          title: 'Общее количество учебных часов',
          dataIndex: ['totalSubjectHours'],
        },
        {
          key: 'availableSlots',
          title: 'Доступное количество слотов',
          dataIndex: ['availableSlots'],
        },
      ];
    case 'MISSING_OR_INVALID_SUBJECT_DIFFICULTY':
      return [
        {
          key: 'educationalClass',
          title: 'Класс',
          dataIndex: ['educationalClass'],
          maxWidth: '100px',
          render: (value: EducationClass) =>
            `${educationParallelTextRepresentation[value.parallel]}${value.litera}`,
        },
        {
          key: 'subjectName',
          title: 'Предмет',
          dataIndex: ['subjectName'],
        },
        {
          key: 'difficulty',
          title: 'Сложность предмета',
          dataIndex: ['difficulty'],
          render: () => 'Не указано',
        },
      ];
    case 'NO_TEACHER_FOR_MANDATORY_IMPLICIT_LESSON':
      return [
        {
          key: 'educationalClass',
          title: 'Класс',
          dataIndex: ['educationalClass'],
          maxWidth: '100px',
          render: (value: EducationClass) =>
            `${educationParallelTextRepresentation[value.parallel]}${value.litera}`,
        },
        {
          key: 'subjectName',
          title: 'Предмет',
          dataIndex: ['subjectName'],
        },
        {
          key: 'dayOfWeek',
          title: 'День недели',
          dataIndex: ['dayOfWeek'],
          render: (value: DayOfWeek) => translateDay(value),
        },
        {
          key: 'lessonIndex',
          title: 'Урок',
          dataIndex: ['lessonIndex'],
          render: (value: Lesson) => getLessonBellTime(value, currentBellSchedule),
        },
      ];
    case 'NO_ROOM_FOR_MANDATORY_IMPLICIT_LESSON':
      return [
        {
          key: 'educationalClass',
          title: 'Класс',
          dataIndex: ['educationalClass'],
          maxWidth: '100px',
          render: (value: EducationClass) =>
            `${educationParallelTextRepresentation[value.parallel]}${value.litera}`,
        },
        {
          key: 'subjectName',
          title: 'Предмет',
          dataIndex: ['subjectName'],
        },
        {
          key: 'dayOfWeek',
          title: 'День недели',
          dataIndex: ['dayOfWeek'],
          render: (value: DayOfWeek) => translateDay(value),
        },
        {
          key: 'lessonIndex',
          title: 'Урок',
          dataIndex: ['lessonIndex'],
          render: (value: Lesson) => getLessonBellTime(value, currentBellSchedule),
        },
      ];
    default:
      return [
        {
          key: 'details',
          title: 'Данные нарушения',
          dataIndex: [],
          render: (value: unknown) => JSON.stringify(value),
        },
      ];
  }
};
